import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import api from './services/api';
import Layout from './components/Layout';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ReviewsPage from './pages/ReviewsPage';
import BillingPage from './pages/BillingPage';
import './styles/app.css';
import './styles/landing.css';
import SettingsPage from './pages/SettingsPage';
import ConnectionsPage from './pages/ConnectionsPage';
import GoogleCallback from './pages/GoogleCallback';
import AdminPage from './pages/AdminPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import SupportPage from './pages/SupportPage';
import FeedbackFunnelPage from './pages/FeedbackFunnelPage';
import FeedbackPage from './pages/FeedbackPage';
import CompetitorsPage from './pages/CompetitorsPage';
import AuditPage from './pages/AuditPage';
import FreeReplyGeneratorPage from './pages/FreeReplyGeneratorPage';
import AirbnbAuditPage from './pages/AirbnbAuditPage';
import ForAirbnbHostsPage from './pages/ForAirbnbHostsPage';
import ListingStandingPage from './pages/ListingStandingPage';
import RecoveryPage from './pages/RecoveryPage';
import ListingIntelligencePage from './pages/ListingIntelligencePage';
import ForecastPage from './pages/ForecastPage';

function ProtectedRoute({ children }) {
  if (!api.isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  return <Layout>{children}</Layout>;
}

function HomeRoute() {
  if (api.isAuthenticated()) {
    return <Layout><DashboardPage /></Layout>;
  }
  return <LandingPage />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeRoute />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reviews" element={<ProtectedRoute><ReviewsPage /></ProtectedRoute>} />
        <Route path="/feedback" element={<ProtectedRoute><FeedbackPage /></ProtectedRoute>} />
        <Route path="/competitors" element={<ProtectedRoute><CompetitorsPage /></ProtectedRoute>} />
        <Route path="/billing" element={<ProtectedRoute><BillingPage /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path="/connections" element={<ProtectedRoute><ConnectionsPage /></ProtectedRoute>} />
        <Route path="/settings/google/callback" element={<ProtectedRoute><GoogleCallback /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/support" element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
        <Route path="/r/:slug" element={<FeedbackFunnelPage />} />
        <Route path="/audit" element={<AuditPage />} />
        <Route path="/free-review-response-generator" element={<FreeReplyGeneratorPage />} />
        <Route path="/free-airbnb-review-response-generator" element={<FreeReplyGeneratorPage variant="airbnb" />} />
        <Route path="/audit/r/:shareId" element={<AuditPage />} />
        <Route path="/free-airbnb-listing-audit" element={<AirbnbAuditPage />} />
        <Route path="/airbnb-audit/r/:shareId" element={<AirbnbAuditPage />} />
        <Route path="/for-airbnb-hosts" element={<ForAirbnbHostsPage />} />
        <Route path="/airbnb-superhost-checker" element={<ListingStandingPage />} />
        <Route path="/standing/r/:shareId" element={<ListingStandingPage />} />
        <Route path="/recovery" element={<ProtectedRoute><RecoveryPage /></ProtectedRoute>} />
        <Route path="/listing-intelligence" element={<ProtectedRoute><ListingIntelligencePage /></ProtectedRoute>} />
        <Route path="/forecast" element={<ProtectedRoute><ForecastPage /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}
